import { PATIENT_APP_URL } from './constants';
import { ProfileClient } from '../api/client';
import axios from 'axios';

export function profileClient() {
  return new ProfileClient(PATIENT_APP_URL, axios);
}
